import produce from 'immer';

const initialState = {
  list: []
};

const businessesReducer = (state=initialState, action) => {
  switch (action.type) {
    case 'BUSINESSES_UPDATE_ALL':
      return { list: action.businesses };
    
    case 'BUSINESSES_UPDATE_ONE':
      let businesses = produce(state.list, draftState => {
        var idx = state.list.findIndex(x => x.id === action.business.id);
        if (idx >= 0) draftState[idx] = action.business;
        else draftState.push(action.business);
        return draftState;
      });

      return { list: businesses }
    
    case 'BUSINESSES_RESET':
      return initialState;
  
    default:
      return state;
  } 
}

export default businessesReducer;